import * as ActionTypes from '~/actions/ActionTypes'

export const setLatestSavedTime = () => async dispatch => {
  await dispatch({ type: ActionTypes.PROJECTS_SET_LATEST_SAVED_TIME })
}
